module.exports = __webpack_public_path__ + "img/Flag_of_Malaysia.417cba3c.svg";